import React from "react";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import NavMenuItem from "./NavMenuItem";
import { LinkToRegisterButton } from "src/library/components/exports";
import { NAV_MENU_ITEMS } from "src/library/constants";
import { useHackathonContext } from "src/library/store/GlobalStateProvider";

export default function MobileNavMenu() {
  const { state } = useHackathonContext();
  const theme = useTheme();
  const WHEN_MOBILE = useMediaQuery(theme.breakpoints.down("sm"));
  const [footerHeight, setFooterHeight] = React.useState(248); // desktop

  React.useEffect(() => {
    if (WHEN_MOBILE) setFooterHeight(265);
  }, [WHEN_MOBILE]);

  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: `calc(100vh - ${footerHeight}px)`,
        pt: 8,
        backgroundColor: "common.black",
      }}
      component="nav"
    >
      <List>
        {NAV_MENU_ITEMS.map((section, index) => (
          <ListItem
            disablePadding={WHEN_MOBILE}
            key={`mobile-nav-item-${index}`}
            data-aos="fade-up"
            data-aos-offset="200"
            data-aos-duration="400"
            data-aos-easing="ease-in-out"
          >
            <NavMenuItem section={section} />
          </ListItem>
        ))}
      </List>

      {state.registrationsAvailable && (
        <LinkToRegisterButton buttonText="Register Your Interest" />
      )}
    </Container>
  );
}
